import { render, staticRenderFns } from "./audienceSource.vue?vue&type=template&id=67660e6e&scoped=true"
import script from "./audienceSource.vue?vue&type=script&lang=js"
export * from "./audienceSource.vue?vue&type=script&lang=js"
import style0 from "./audienceSource.vue?vue&type=style&index=0&id=67660e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67660e6e",
  null
  
)

export default component.exports